export default function LandingNueva() {
  const serif = { fontFamily: "Georgia, serif" };
  const sans = { fontFamily: "Arial, sans-serif" };

  return (
    <div className="min-h-screen bg-white text-[#3D3D3B]">
      {/* 1. NAV */}
      <nav
        className="sticky top-0 z-50 border-b border-[#E5E7EB] bg-white"
        style={{ borderBottomWidth: "1px", borderBottomStyle: "solid" }}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
          <a href="#" className="flex items-center">
            <img
              src="/brand/aurora_logo_navbar.png"
              alt="Aurora Geriátrica"
              style={{ height: "44px", width: "auto" }}
            />
          </a>

          <div className="hidden items-center gap-7 md:flex">
            <a href="#funciones" className="text-sm text-[#3D3D3B] transition-colors hover:text-[#1B3A6B]" style={sans}>
              Funciones
            </a>
            <a href="#escalas" className="text-sm text-[#3D3D3B] transition-colors hover:text-[#1B3A6B]" style={sans}>
              Escalas
            </a>
            <a href="#universidades" className="text-sm text-[#3D3D3B] transition-colors hover:text-[#1B3A6B]" style={sans}>
              Para universidades
            </a>
            <a href="#precios" className="text-sm text-[#3D3D3B] transition-colors hover:text-[#1B3A6B]" style={sans}>
              Precios
            </a>
          </div>

          <a
            href="https://app.aurorageriatrica.com/register"
            className="rounded-md border border-[#1B3A6B] px-4 py-2 text-sm text-[#1B3A6B] transition-colors hover:bg-[#1B3A6B] hover:text-white"
            style={sans}
          >
            Probar gratis
          </a>
        </div>
      </nav>

      {/* 2. HERO */}
      <section
        style={{
          minHeight: "90vh",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          background: "#FAF8F4",
        }}
        className="max-md:!grid-cols-1"
      >
        <div
          style={{
            padding: "80px 60px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          className="max-md:!px-6 max-md:!py-16"
        >
          <span
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "11px",
              letterSpacing: "3px",
              textTransform: "uppercase",
              color: "#EF9F27",
              marginBottom: "24px",
            }}
          >
            Plataforma clínica especializada · Latinoamérica
          </span>
          <h1
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "52px",
              fontWeight: "400",
              color: "#1B3A6B",
              lineHeight: "1.1",
              marginBottom: "24px",
            }}
            className="max-md:!text-4xl"
          >
            El geriatra de LATAM merece una herramienta a su altura
          </h1>
          <p
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "17px",
              color: "#5F5E5A",
              lineHeight: "1.7",
              maxWidth: "460px",
              marginBottom: "40px",
            }}
          >
            Expediente geriátrico organizado, agenda clínica e informes profesionales para consultorio y seguimiento.
          </p>
          <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
            <a
              href="https://app.aurorageriatrica.com/register"
              style={{
                background: "#1B3A6B",
                color: "#FFFFFF",
                padding: "14px 28px",
                borderRadius: "6px",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Probar gratis 14 días
            </a>
            <a
              href="#demo"
              style={{
                color: "#1B3A6B",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                textDecoration: "none",
                borderBottom: "1px solid #1B3A6B",
                paddingBottom: "2px",
              }}
            >
              Ver demostración →
            </a>
          </div>
          <p
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "12px",
              color: "#888780",
              marginTop: "16px",
            }}
          >
            Sin tarjeta de crédito · Acceso inmediato · Cancelación libre
          </p>
        </div>
        <div
          style={{
            background: "#E8EDF3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "500px",
          }}
        >
          <p
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "13px",
              color: "#8B9BB4",
              textAlign: "center",
            }}
          >
            📷 Foto: médico con paciente adulto mayor
            <br />
            <span style={{ fontSize: "11px" }}>Pendiente de agregar</span>
          </p>
        </div>
      </section>

      {/* 3. BARRA DE VALIDACIÓN */}
      <section className="border-y border-[#E5E7EB] bg-white">
        <div
          className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-5 sm:flex-row sm:justify-center sm:gap-0 sm:divide-x sm:divide-[#E5E7EB] sm:px-6"
          style={{ ...sans, fontSize: "12px", color: "#5F5E5A", paddingTop: "20px", paddingBottom: "20px" }}
        >
          {[
            "✓ Validado por Dr. Joel López Navarro — Decano Geriatría, U. San Pablo",
            "✓ Semifinalista CodeLaunch LATAM 2026",
            "✓ Expediente geriátrico y agenda clínica",
          ].map((item) => (
            <div key={item} className="px-5 text-center sm:text-left">
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* 4. PROBLEMA */}
      <section className="bg-white px-4 py-24 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-2 md:items-center md:gap-16">
          <div
            className="flex min-h-[360px] items-center justify-center rounded-2xl"
            style={{ background: "#F0EDE8" }}
          >
            <p className="px-6 text-center text-sm text-[#8B9BB4]" style={sans}>
              📷 Sin Aurora — documentación manual
              <br />
              <span className="text-xs">Pendiente de agregar</span>
            </p>
          </div>

          <div>
            <p
              className="mb-4 text-xs uppercase tracking-[3px] text-[#EF9F27]"
              style={sans}
            >
              El problema real
            </p>
            <h2
              className="mb-6 text-4xl font-normal leading-tight text-[#1B3A6B] md:text-5xl"
              style={serif}
            >
              La geriatría no cabe en un sistema genérico
            </h2>
            <p
              className="mb-8 max-w-md text-[17px] leading-relaxed text-[#5F5E5A]"
              style={sans}
            >
              Los EMR generales no contemplan escalas geriátricas, alertas de
              fragilidad ni el ritmo real de una valoración integral. El
              resultado: horas de papel y decisiones clínicas fragmentadas.
            </p>
            <ul className="space-y-4" style={sans}>
              {[
                "Escalas en papel, cálculo manual y errores de puntuación",
                "2–3 horas de documentación por paciente",
                "Informes reescritos desde cero en cada visita",
              ].map((item) => (
                <li key={item} className="flex gap-3 text-[#3D3D3B]">
                  <span className="shrink-0 text-red-400">✗</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* 5. SOLUCIÓN */}
      <section
        id="funciones"
        className="px-4 py-24 sm:px-6 lg:px-8"
        style={{ background: "#FAF8F4" }}
      >
        <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-2 md:items-center md:gap-16">
          <div>
            <p
              className="mb-4 text-xs uppercase tracking-[3px] text-[#EF9F27]"
              style={sans}
            >
              Con Aurora
            </p>
            <h2
              className="mb-6 text-4xl font-normal leading-tight text-[#1B3A6B] md:text-5xl"
              style={serif}
            >
              Consultas estructuradas en el consultorio
            </h2>
            <ul className="mb-10 space-y-4" style={sans}>
              {[
                "Consultas estructuradas e historial del paciente",
                "Agenda clínica y continuidad de seguimiento",
                "PDF profesional generado al instante",
                "Historial longitudinal por paciente",
                "8 alertas clínicas en tiempo real",
              ].map((item) => (
                <li key={item} className="flex gap-3 text-[#3D3D3B]">
                  <span className="shrink-0 text-emerald-600">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <a
              href="https://app.aurorageriatrica.com/register"
              className="inline-block rounded-md border border-[#1B3A6B] px-6 py-3 text-sm text-[#1B3A6B] transition-colors hover:bg-[#1B3A6B] hover:text-white"
              style={sans}
            >
              Probar gratis 14 días
            </a>
          </div>

          <div
            id="demo"
            className="flex min-h-[360px] items-center justify-center rounded-2xl"
            style={{ background: "#E8EDF3" }}
          >
            <p className="px-6 text-center text-sm text-[#8B9BB4]" style={sans}>
              📷 Aurora en uso — expediente y consulta estructurada
              <br />
              <span className="text-xs">Pendiente de agregar</span>
            </p>
          </div>
        </div>
      </section>

      {/* 6. FUNDADORES */}
      <section className="bg-white px-4 py-24 text-center sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          <p
            className="mb-4 text-xs uppercase tracking-[3px] text-[#EF9F27]"
            style={sans}
          >
            Quiénes somos
          </p>
          <h2
            className="mb-4 text-4xl font-normal leading-tight text-[#1B3A6B] md:text-5xl"
            style={serif}
          >
            Construido por una geriatra, para geriatras
          </h2>
          <p
            className="mx-auto mb-14 max-w-xl text-[17px] leading-relaxed text-[#5F5E5A]"
            style={sans}
          >
            No somos una empresa de tecnología que adaptó un software médico.
          </p>

          <div className="grid gap-6 text-left md:grid-cols-2">
            <div
              className="rounded-2xl border border-[#E5E7EB] bg-white p-8"
              style={{ borderRadius: "16px", padding: "32px" }}
            >
              <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#1B3A6B] text-sm font-semibold text-white">
                RM
              </div>
              <h3 className="text-xl text-[#1B3A6B]" style={serif}>
                Dra. Rosario Morales
              </h3>
              <p className="mt-1 text-sm text-[#5F5E5A]" style={sans}>
                Cofundadora · Directora Médica
              </p>
              <p className="mt-4 text-sm leading-relaxed text-[#5F5E5A]" style={sans}>
                Geriatra y Gerontóloga. Diseñó cada escala y validó cada flujo
                clínico. Aurora refleja su práctica diaria con adultos mayores
                en Latinoamérica.
              </p>
            </div>

            <div
              className="rounded-2xl border border-[#E5E7EB] bg-white p-8"
              style={{ borderRadius: "16px", padding: "32px" }}
            >
              <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#EF9F27] text-sm font-semibold text-[#1B3A6B]">
                LC
              </div>
              <h3 className="text-xl text-[#1B3A6B]" style={serif}>
                Luis Fernando Chacón
              </h3>
              <p className="mt-1 text-sm text-[#5F5E5A]" style={sans}>
                Cofundador · CEO técnico
              </p>
              <p className="mt-4 text-sm leading-relaxed text-[#5F5E5A]" style={sans}>
                Emprendedor guatemalteco. Construyó Aurora desde cero para
                resolver el problema clínico que su esposa enfrentaba cada día
                en consulta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 7. TESTIMONIO */}
      <section className="bg-[#1B3A6B] px-4 py-24 text-center sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl">
          <span
            className="mb-4 block text-7xl leading-none text-[#EF9F27]"
            style={serif}
            aria-hidden
          >
            &ldquo;
          </span>
          <blockquote
            className="text-3xl font-normal leading-snug text-[#FAF8F4] md:text-4xl"
            style={serif}
          >
            Aurora es oro puro para la formación geriátrica. El flujo clínico
            refleja exactamente cómo debe hacerse una valoración integral.
          </blockquote>
          <p className="mt-10 font-semibold text-[#EF9F27]" style={sans}>
            Dr. Joel Alejandro López Navarro
          </p>
          <p className="mt-2 text-sm text-[#7BC8F0]" style={sans}>
            Decano del Programa de Geriatría · Universidad San Pablo de Guatemala
            · Miembro AGMA
          </p>
        </div>
      </section>

      {/* 8. ESCALAS */}
      <section
        id="escalas"
        className="px-4 py-24 sm:px-6 lg:px-8"
        style={{ background: "#FAF8F4" }}
      >
        <div className="mx-auto max-w-6xl">
          <p
            className="mb-4 text-xs uppercase tracking-[3px] text-[#EF9F27]"
            style={sans}
          >
            Consultas e historial organizados
          </p>
          <h2
            className="mb-14 max-w-xl text-4xl font-normal leading-tight text-[#1B3A6B] md:text-5xl"
            style={serif}
          >
            Consultas estructuradas. Historial visible.
          </h2>

          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { name: "Expediente", score: "Unificado", interp: "Historia y consultas en un solo lugar", pct: 90, color: "#2B8CC4" },
              { name: "Agenda", score: "Clínica", interp: "Citas y seguimiento del consultorio", pct: 80, color: "#EF9F27" },
              { name: "Informes", score: "PDF", interp: "Documentos profesionales de la consulta", pct: 85, color: "#34A853" },
              { name: "Historial", score: "Continuo", interp: "Evolución del paciente entre visitas", pct: 88, color: "#2B8CC4" },
              { name: "Consultas", score: "Estructuradas", interp: "Motivo, examen y plan en un flujo", pct: 82, color: "#EF9F27" },
              { name: "Seguimiento", score: "Clínico", interp: "Continuidad después de la visita", pct: 78, color: "#34A853" },
            ].map((scale) => (
              <div
                key={scale.name}
                className="rounded-xl border border-[#E5E7EB] bg-white p-6"
                style={{ borderRadius: "12px" }}
              >
                <p className="text-lg text-[#1B3A6B]" style={serif}>
                  {scale.name}
                </p>
                <p className="mt-2 text-2xl font-normal text-[#3D3D3B]" style={sans}>
                  {scale.score}
                </p>
                <p className="mt-1 text-sm text-[#5F5E5A]" style={sans}>
                  {scale.interp}
                </p>
                <div className="mt-4 h-2 overflow-hidden rounded-full bg-[#E8EDF3]">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${scale.pct}%`, background: scale.color }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 9. PRECIO */}
      <section
        id="precios"
        className="bg-white px-4 py-24 text-center sm:px-6 lg:px-8"
      >
        <div className="mx-auto max-w-5xl">
          <h2
            className="mb-12 text-4xl font-normal leading-tight text-[#1B3A6B] md:text-5xl"
            style={serif}
          >
            Un plan. Todo incluido.
          </h2>

          <div className="mx-auto max-w-sm rounded-2xl border-2 border-[#EF9F27] bg-white p-10 text-left">
            <p className="text-6xl font-normal text-[#1B3A6B]" style={serif}>
              $39
            </p>
            <p className="mt-1 text-sm text-[#5F5E5A]" style={sans}>
              USD / mes · 1 perfil médico
            </p>

            <ul className="mt-8 space-y-3 text-sm text-[#3D3D3B]" style={sans}>
              {[
                "Pacientes ilimitados",
                "Consultas estructuradas e historial",
                "Informes PDF profesionales",
                "Historial longitudinal",
                "8 alertas clínicas automáticas",
                "Soporte en español",
              ].map((feature) => (
                <li key={feature} className="flex gap-3">
                  <span className="shrink-0 text-[#EF9F27]">✓</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://app.aurorageriatrica.com/register"
              className="mt-8 block w-full rounded-xl bg-[#1B3A6B] py-4 text-center text-sm font-semibold text-white transition-opacity hover:opacity-90"
              style={sans}
            >
              Probar gratis 14 días
            </a>
            <p className="mt-4 text-center text-xs text-[#888780]" style={sans}>
              Sin tarjeta · Cancelación libre · 14 días gratis
            </p>
          </div>

          <a
            id="universidades"
            href="#"
            className="mt-8 inline-block text-sm text-[#2B8CC4] transition-colors hover:text-[#1B3A6B]"
            style={sans}
          >
            ¿Universidad o centro geriátrico? Ver planes institucionales →
          </a>
        </div>
      </section>

      {/* 10. FOOTER */}
      <footer className="bg-[#1B3A6B] px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-6xl flex-col gap-8 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-3">
            <img
              src="/brand/aurora_logo_navbar_blanco.png"
              alt="Aurora Geriátrica"
              style={{ height: "40px", width: "auto" }}
            />
            <p className="text-sm text-[#7BC8F0]" style={sans}>
              Expediente geriátrico para Latinoamérica
            </p>
          </div>

          <div className="flex flex-wrap gap-5 text-sm text-[#7BC8F0]" style={sans}>
            <a href="/privacidad" className="hover:text-white">
              Privacidad
            </a>
            <a href="/terminos" className="hover:text-white">
              Términos
            </a>
            <a href="/contacto" className="hover:text-white">
              Contacto
            </a>
            <a href="#universidades" className="hover:text-white">
              Para universidades
            </a>
          </div>

          <p className="text-xs text-[#7BC8F0]" style={sans}>
            © 2026 Aurora Geriátrica
          </p>
        </div>
      </footer>
    </div>
  );
}
